import { errorResponseGetMsg } from "../helpers/errorResponseHelpers";
import { replaceIdURL } from "../helpers/replaceId";
import { Endpoints } from "./type_endpoints";
import { apiaxios } from "./axios";

const responseAxios = (status = 0, msg = "", payload = null) => {
    return {
        status,
        msg,
        payload,
    };
};

export const getRequestUsersTable = async () => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.user.post_and_getall}?inactive=true`)
        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
};
export const getUserTableGeneral = async () => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.user.get_getUserTable}`)
        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
};

export const deleteRequestUsers = async (email) => {
    try {
        const url = replaceIdURL(Endpoints.user.putUser_deleteUser, "email", email);
        const { data } = await apiaxios.delete(`${url}`);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
};

export const createRequestUsers = async (form) => {
    try {
        const { data } = await apiaxios.post(`${Endpoints.user.post_and_getall}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
};

export const updateRequestUsers = async (email, structureForm) => {
    try {
        const url = replaceIdURL(Endpoints.user.putUser_deleteUser, "email", email);
        const { data } = await apiaxios.put(`${url}`, structureForm);
        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
};

export const postRequestLogin = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.auth.login, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        const rest = error.response;
        if (!rest.data)
            return responseAxios(500, "Error del servidor", []);
        if (rest.data.status === 1) {
            return responseAxios(1, "No existe el usuario", []);
        } else if (rest.data.status === 3) {
            return responseAxios(3, "Contraseña incorrecta", []);
        }
        else {
            return responseAxios(500, "Error del servidor", []);
        }

    }
};

export const getRequestProjectCategories = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.graph.category);
        return responseAxios(0, data.msg, data.payload.categories);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener categorias", []);
    }
};
export const getRequestProjectSize = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.graph.size);
        return responseAxios(0, data.msg, data.payload.graph);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener el tamaño de categorias", []);
    }
};

export const getRequestProjectLeaders = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.graph.leaders);
        return responseAxios(0, data.msg, data.payload.graph);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener distribución de lideres", []);
    }
};
export const getRequestProjectLeadersMinified = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.graph.leadersProjects);
        return responseAxios(0, data.msg, data.payload.leaders);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener distribución de lideres", []);
    }
};

export const getRequestProjectTable = async (own = null) => {
    try {
        if (own) {
            const { data } = await apiaxios.get(`${Endpoints.project.getAllProject}?own=true`);
            return responseAxios(0, data.msg, data.payload);
        }
        const { data } = await apiaxios.get(`${Endpoints.project.getAllProject}?own=false`);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const getRequestProjectTableClickup = async (own = null, year = 2023) => {
    try {
        const isOwned = own ? "true" : "false";
        const { data } = await apiaxios.get(`${Endpoints.project.entries}?own=${isOwned}&year=${year}`);
        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, error.response, []);
    }
};

export const getRequestProjectDetails = async (id = null) => {
    try {
        const url = replaceIdURL(Endpoints.project.detail, "spaceId", id);
        const url2 = replaceIdURL(Endpoints.project.getTaskEstimate, "spaceId", id);
        const [{ data: projectApi }, { data: projectEstimateHours }] = await Promise.all([apiaxios.get(url), apiaxios.get(url2)]);
        let structorAPi = {
            ...projectApi.payload.project,
            backups: projectApi.payload.backups,
            retrospective: projectApi.payload.comments,
            projectRed: projectApi.payload.overTimeComments,
            taskHours: projectEstimateHours.payload.tasks,
        };
        return responseAxios(0, "", structorAPi);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la información de un proyecto", []);
    }
};

export const getRequestProjectDetailsEntries = async (id = null) => {
    try {
        const url = replaceIdURL(Endpoints.project.tasks, "spaceId", id);
        const { data: projectApi } = await apiaxios.get(url);
        let structorAPi = {
            ...projectApi.payload.detail,
        };
        return responseAxios(0, "", structorAPi);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la información de un proyecto", []);
    }
};
export const getRequestProjectProjection = async (id = null) => {
    try {
        const url = replaceIdURL(Endpoints.project.proyection, "spaceId", id);
        const {
            data: { payload },
        } = await apiaxios.get(url);
        return responseAxios(0, "", payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la projección del proyecto", []);
    }
};

export const putUpdateTaskByClickupSpace = async ({ clickupSpaces = [""] }) => {
    try {
        const {
            data: { status, payload },
        } = await apiaxios.put(Endpoints.project.updateTaskByClickupSpaceV2, { clickupSpaces });
        return responseAxios(status, "", payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la projección del proyecto", []);
    }
};

export const getRequestProjectDetailsEntriesV2 = async (id = null) => {
    try {
        const url = replaceIdURL(Endpoints.project.getEntriesBySpace, "spaceId", id);
        const {
            data: { payload },
        } = await apiaxios.get(url);
        return responseAxios(0, "", payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la información de un proyecto", []);
    }
};

export const getRequestVerificateToken = async () => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.auth.check_token}`);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al verificar token", []);
    }
};

export const createSaveUpdateHours = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.updateHours.create, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al verificar token", []);
    }
};

export const deleteResponseUpdateHours = async ({ backupId, spaceId }) => {
    try {
        const urlbackup = replaceIdURL(Endpoints.updateHours.delete, "backupId", backupId);
        const url = replaceIdURL(urlbackup, "spaceId", spaceId);
        const { data } = await apiaxios.delete(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al verificar token", []);
    }
};

export const putUpdateHours = async (form) => {
    try {
        const { data } = await apiaxios.put(Endpoints.updateHours.create, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al verificar token", []);
    }
};

export const createExtraResource = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.extraresource.create, form);
        return responseAxios(0, "creado", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, error.response, []);
    }
};
export const putExtraResource = async (form) => {
    try {
        const { data } = await apiaxios.put(Endpoints.extraresource.create, form);
        return responseAxios(0, "creado", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, error.response, []);
    }
};
export const deleteExtraResourceProject = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.extraresource.delete, "resourceId", id);
        const { data } = await apiaxios.delete(url);
        return responseAxios(0, "creado", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, error.response, []);
    }
};

export const createRequestNewProject = async (form) => {
    try {
        const { data } = await apiaxios.post(`${Endpoints.project.create}`, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response.data);
        const msg = error.response.data ? error.response.data.msg : "Error al crear proyecto";
        return responseAxios(1, msg, []);
    }
};

export const getRequestDataNewProject = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.project.getProjectClickup);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la informacio de crear proyecto", []);
    }
};

export const getRequestAreasInmersys = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.area.global);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener la areas de inmersys", []);
    }
};

export const createRequestAreasInmersys = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.area.global, form);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear las areas de inmersys", []);
    }
};

export const editRequestAreasInmersys = async (id, form) => {
    try {
        const url = `${Endpoints.area.global}?byId=${id}`;
        const { data } = await apiaxios.put(`${url}`, form);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar las areas de inmersys", []);
    }
};

export const deleteRequestAreasInmersys = async (id) => {
    try {
        const url = `${Endpoints.area.global}?byId=${id}`;
        const { data } = await apiaxios.delete(`${url}`);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al eliminar las areas de inmersys", []);
    }
};

export const editRequestTeamAreasInmersys = async (id, number) => {
    try {
        const url = replaceIdURL(Endpoints.area.team, "id", id);
        const { data } = await apiaxios.put(`${url}`, { isTeam: number });
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar el team de las areas de inmersys", []);
    }
};

export const getFormProjectInfo = async (id, number) => {
    try {
        const [{ data: plataformsApi }, { data: categoriesAPi }] = await Promise.all([
            apiaxios.get(`${Endpoints.platform.getall_create}?getInactives=false`),
            apiaxios.get(Endpoints.category.getall_create),
        ]);
        let structorAPi = {
            platforms: plataformsApi.payload,
            categories: categoriesAPi.payload,
        };
        return responseAxios(0, "Obtener", structorAPi);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar el team de las areas de inmersys", []);
    }
};

export const getFormProjectTeam = async () => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.user.post_and_getall}`);

        return responseAxios(0, "Obtener", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar el team de las areas de inmersys", []);
    }
};

export const getReasonPause = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.pauseReason.getAll);
        return responseAxios(0, "Obtener", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener las razonas de pausa", []);
    }
};

export const createReasonPause = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.pauseReason.getAll, form);
        return responseAxios(0, "Obtener", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener las razonas de pausa", []);
    }
};
export const putReasonPause = async (form) => {
    try {
        const { data } = await apiaxios.put(Endpoints.pauseReason.getAll, form);
        return responseAxios(0, "Obtener", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener las razonas de pausa", []);
    }
};
export const deleteRequestReasonPause = async (form) => {
    try {
        const { data } = await apiaxios.delete(`${Endpoints.pauseReason.getAll}?id=${form.id}&status=${form.status}`, { form });
        return responseAxios(0, "Obtener", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener las razonas de pausa", []);
    }
};

export const createReasonPauseForProject = async (form) => {
    try {
        const { data } = await apiaxios.put(Endpoints.pauseReason.updateProject, form);
        return responseAxios(0, "crear", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", error.response);
    }
};
export const updateReasonPauseForProject = async (idpause = 0, spaceId = 0, form = { reasons: [], finishDate: "" }) => {
    try {
        const url = replaceIdURL(Endpoints.pauseReason.resetUpdate, "pauseId", idpause);
        const { data } = await apiaxios.put(url, { spaceId: spaceId, ...form });
        return responseAxios(0, "crear", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const updatePauseForProject = async (idpause = 0, spaceId = 0, form = { initDate: "", finishDate: "", reasonsId: [] }) => {
    try {
        const url = replaceIdURL(Endpoints.pauseReason.editPause, "pauseId", idpause);
        const { data } = await apiaxios.put(url, { spaceId: spaceId, ...form });
        return responseAxios(0, "crear", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const deletePauseForProject = async (idpause = 0, spaceId = 0) => {
    try {
        const url = replaceIdURL(Endpoints.pauseReason.deletePause, "pauseId", idpause);
        const finalUrl = replaceIdURL(url, "spaceId", spaceId);
        const { data } = await apiaxios.delete(finalUrl);
        return responseAxios(0, "crear", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const putProject = async (url = "", form) => {
    try {
        const { data } = await apiaxios.put(url, form);
        return responseAxios(0, "crear", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const createProjectinRed = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.projectred.create, form);
        return responseAxios(data.status, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear project en red", []);
    }
};

export const putHasCommentProject = async (id, status = true) => {
    try {
        const url = replaceIdURL(Endpoints.project.hasComment, "spaceId", id);
        const { data } = await apiaxios.put(url, { status });
        return responseAxios(0, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(2, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const createProjectRetrospective = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.retrospective.comment, form);
        return responseAxios(data.status, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const editCommentProjectRetrospective = async (form) => {
    try {
        const { data } = await apiaxios.put(Endpoints.retrospective.edit, form);
        return responseAxios(data.status, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const sendEmailCommentProjectRetrospective = async (spaceId) => {
    try {
        const url = replaceIdURL(Endpoints.retrospective.sendEmail, "clickUpSpace", spaceId);
        const { data } = await apiaxios.get(url);
        return responseAxios(data.status, "send Email", "Creado");
    } catch (error) {
        console.log(error.response);
        const msg = error.response.data?.msg
        if (msg === undefined) return responseAxios(1, "Error al mandar email proyecto", "Error en el servidor");
        return responseAxios(1, "Error al mandar email proyecto", msg.text);
    }
};

export const deleteCommentProjectRetrospective = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.retrospective.delete, "id", id);
        const { data } = await apiaxios.delete(url);
        return responseAxios(data.status, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const getAllRetrospective = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.retrospective.getComment, "clickUpSpace", id);
        const { data } = await apiaxios.get(url);
        return responseAxios(0, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const reactiveProject = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.reactiveProject, "spaceId", id);
        const { data } = await apiaxios.put(url);
        return responseAxios(0, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const createForProjectByHoursWork = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.project.addHours, form);
        return responseAxios(0, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const finishProject = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.project.finishproject, "spaceId", id);
        const { data } = await apiaxios.put(url, form);
        return responseAxios(0, "crear", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        const { data = undefined } = error.response;
        if (data !== undefined) {
            if (data.status === 2) {
                return responseAxios(2, data.msg, []);
            }
        }
        return responseAxios(1, error.response, []);
    }
};

export const putRequestReactiveCancelProject = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.reactive, "spaceId", id);
        const { data } = await apiaxios.put(url);
        return responseAxios(0, "cancel", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const getRequestUpdateTime = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.updatetime, "spaceId", id);
        const { data } = await apiaxios.get(url);
        return responseAxios(0, "update", data.payload.reasons);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const deleteRequestProject = async (id) => {
    try {
        const { data } = await apiaxios.delete(`${Endpoints.project.create}?spaceId=${id}`);
        return responseAxios(0, "eliminado", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear recursos extras", []);
    }
};

export const deleteRequestCategory = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.category.put_delete, "id", id);
        const { data } = await apiaxios.delete(`${url}`);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar las areas de inmersys", []);
    }
};
export const getAllRequestCategories = async () => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.category.getall_create}?inactive=true`);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar las areas de inmersys", []);
    }
};

export const createRequestCategory = async (form) => {
    try {
        const { data } = await apiaxios.post(`${Endpoints.category.getall_create}`, form);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar las areas de inmersys", []);
    }
};

export const getRequestAllUser = async (form) => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.user.post_and_getall}?inactive=true`);
        return responseAxios(0, data.status, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obteer user", []);
    }
};

export const getRequestAllUserArea = async (form) => {
    try {
        const [{ data: usersApi }, { data: areasApi }] = await Promise.all([
            await apiaxios.get(`${Endpoints.user.post_and_getall}?inactive=true`),
            await apiaxios.get(`${Endpoints.area.global}`),
        ]);
        return responseAxios(0, "", { users: usersApi.payload, areas: areasApi.payload });
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obteer user", []);
    }
};

export const setRequestSaveHoursExtra = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.extratime.save, form);
        return responseAxios(0, "creado", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear horas extras", []);
    }
};

export const setRequestPutHoursExtra = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.extratime.edit, "extraTimeId", id);
        const { data } = await apiaxios.put(url, form);
        return responseAxios(0, "creado", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear horas extras", []);
    }
};

export const deleteRequestHoursExtra = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.extratime.edit, "extraTimeId", id);
        await apiaxios.delete(url);
        return responseAxios(0, "eliinado", {});
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear horas extras", []);
    }
};

export const getRequestGraphSectionArea = async (year = new Date().getFullYear()) => {
    const url = Endpoints.graph.sectionArea + "?year=" + year;
    try {
        const { data } = await apiaxios.get(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al obtener secciones", []);
    }
};

export const getRequestGraphSection = async (year = new Date().getFullYear()) => {
    const url = Endpoints.graph.section + "?year=" + year;
    try {
        const { data } = await apiaxios.get(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al obtener secciones", []);
    }
};

export const reloadSectionBySectionId = async (sectionId) => {
    const url = replaceIdURL(Endpoints.graph.reloadSectionById, "sectionId", sectionId);
    try {
        const { data } = await apiaxios.put(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al recargar seccion ", []);
    }
};

export const getClickupSpaceForSection = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.graph.clickupSpaceInmersys);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al recargar seccion ", []);
    }
};

export const postClickupListBySpaceForSection = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.graph.clickupListBySpaceInmersys, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al recargar seccion ", []);
    }
};

export const postCreateSection = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.graph.sectionCreate, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al crear seccion ", []);
    }
};

export const putUpdateSection = async (sectionId, form) => {
    const url = replaceIdURL(Endpoints.graph.sectionUpdate, "sectionId", sectionId);
    try {
        const { data } = await apiaxios.put(url, form);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al crear seccion ", []);
    }
};

export const deleteSection = async (sectionId) => {
    const url = replaceIdURL(Endpoints.graph.sectionDelete, "sectionId", sectionId);
    try {
        const { data } = await apiaxios.delete(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        return responseAxios(1, "Error al eliminar seccion ", []);
    }
};

export const reloadAllSection = async (year = new Date().getFullYear()) => {
    const url = Endpoints.graph.reloadSection + "?year=" + year;
    try {
        const { data } = await apiaxios.put(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error);
        return responseAxios(1, "Error al recargar todas las secciones ", []);
    }
};

export const getRequestGraphArea = async (area = "", year) => {
    try {
        const { data } = await apiaxios.get(`${Endpoints.graph.projectArea}/${year}?area=${area}`);
        return responseAxios(0, data.msg, data.payload.graph);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener distribución de lideres", []);
    }
};

export const getRequestGraphSemaforo = async (year) => {
    const url = replaceIdURL(Endpoints.graph.semaforo, "year", year);
    try {
        const { data } = await apiaxios.get(url);
        return responseAxios(0, data.msg, data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener distribución de lideres", []);
    }
};

export const postRequestSemaforo = async (form) => {
    try {
        const { data } = await apiaxios.post(`${Endpoints.graph.semaforo}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const getRequestAllSimulation = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.simulation.getSimulation, "spaceId", id);
        const { data } = await apiaxios.get(`${url}`);
        return responseAxios(0, "", data.payload.simulationValues);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const postRequestimulation = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.simulation.create_update, "spaceId", id);
        const { data } = await apiaxios.post(`${url}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const putRequesSimulation = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.simulation.create_update, "spaceId", id);
        const { data } = await apiaxios.put(`${url}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const getRequesAllDataInitSimulation = async (id) => {
    try {
        const url_assets = replaceIdURL(Endpoints.simulation.get_assets, "spaceId", id);
        const url_provider = replaceIdURL(Endpoints.simulation.get_providers, "spaceId", id);
        const url_clickup = replaceIdURL(Endpoints.project.tasks, "spaceId", id);
        const [{ data: dataAssest }, { data: dataTeamArea }, { data: dataProvider }, { data: dataClickup }] = await Promise.all([
            apiaxios.get(`${url_assets}`),
            apiaxios.get(`${Endpoints.area.isteam}`),
            apiaxios.get(`${url_provider}`),
            apiaxios.get(url_clickup),
        ]);
        const structorJson = {
            assets: dataAssest.payload.assetSimulations,
            teamArea: dataTeamArea.payload,
            providers: dataProvider.payload.simulations,
            clickuphrs: dataClickup.payload.detail,
        };
        return responseAxios(0, "", structorJson);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const getRequesAllSimulationData = async (id) => {
    try {
        const url_assets = replaceIdURL(Endpoints.simulation.get_assets, "spaceId", id);
        const url_equivalency = replaceIdURL(Endpoints.simulation.getSimulation, "spaceId", id);
        const url_provider = replaceIdURL(Endpoints.simulation.get_providers, "spaceId", id);
        const [{ data: dataAssest }, { data: dataEquivalency }, { data: dataProvider }] = await Promise.all([
            apiaxios.get(`${url_assets}`),
            apiaxios.get(`${url_equivalency}`),
            apiaxios.get(`${url_provider}`),
        ]);
        const structorJson = {
            assets: dataAssest.payload.assetSimulations,
            equivalency: dataEquivalency.payload.simulationValues,
            providers: dataProvider.payload.simulations,
        };
        return responseAxios(0, "", structorJson);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const postRequesAssetsSimulation = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.simulation.create_assets, "spaceId", id);
        const { data } = await apiaxios.post(`${url}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const putRequesAssetsSimulation = async (form) => {
    try {
        const { data } = await apiaxios.put(`${Endpoints.simulation.update_assets}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const deleteRequesAssetsSimulation = async (form) => {
    try {
        const { data } = await apiaxios.delete(`${Endpoints.simulation.update_assets}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const postRequesProviderSimulation = async (id, form, typeUrl) => {
    try {
        const urlType = replaceIdURL(Endpoints.simulation.create_provider, "typeUrl", typeUrl);
        const url = replaceIdURL(urlType, "spaceId", id);
        const { data } = await apiaxios.post(`${url}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const putRequesProviderSimulation = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.simulation.edit_provider, "providerSimulationId", id);
        const { data } = await apiaxios.put(`${url}`, form);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const deleteRequesProviderSimulation = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.simulation.delete_providers, "providerSimulationId", id);
        const { data } = await apiaxios.delete(`${url}`);
        return responseAxios(0, "", data);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const getAllHourComparativeRequest = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.backlog.getAll, "spaceId", id);
        const { data } = await apiaxios.get(`${url}`);
        return responseAxios(0, "", data.payload.hourComparative);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al obtener todos los proyectos", []);
    }
};

export const postHourComparativeRequest = async (form) => {
    try {
        const url = Endpoints.backlog.save;
        const { data } = await apiaxios.post(`${url}`, form);
        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear el backlog", []);
    }
};

export const putHourComparativeRequest = async (form) => {
    try {
        const url = Endpoints.backlog.finish;
        const { data } = await apiaxios.put(`${url}`, form);
        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear el backlog", []);
    }
};

export const getProjectsByYear = async (year = 2023) => {
    try {
        const url = replaceIdURL(Endpoints.project.download, "year", year);
        const { data } = await apiaxios.get(url);

        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear el backlog", []);
    }
};

export const getOverTimeProjectComments = async (year) => {
    try {
        const url = replaceIdURL(Endpoints.project.overtime, "year", year);
        const { data } = await apiaxios.get(url);

        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear el backlog", []);
    }
};

export const getAllProjectsByYear = async (year = new Date().getFullYear()) => {
    try {
        const url = replaceIdURL(Endpoints.project.alllProjectsByYear, "year", year);
        const { data } = await apiaxios.get(url);

        return responseAxios(0, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error recuperar proyectos", []);
    }
};

export const createProjectCommentCancel = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.project.canceledComment, form);
        return responseAxios(0, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const getDetailAndSimulation = async (spaceId) => {
    try {
        const url = replaceIdURL(Endpoints.project.simulation, "spaceId", spaceId);
        const { data } = await apiaxios.get(url);

        return responseAxios(0, "crear", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al crear la razon de pausa en el proyecto", []);
    }
};

export const getCountTaskDebugBySpaces = async (spaceId) => {
    try {
        const url = replaceIdURL(Endpoints.project.debug.taskcount, "spaceId", spaceId);
        const { data } = await apiaxios.get(url);
        return responseAxios(0, "Obtener", { taskcount: data.payload });
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar el team de las areas de inmersys", []);
    }
};

export const getLeaderProjectsByYear = async (year) => {
    try {
        const url = replaceIdURL(Endpoints.graph.leaderProjects, "year", year);
        const { data } = await apiaxios.get(url);
        return responseAxios(0, "Obtener", { leaders: data.payload });
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "Error al editar el team de las areas de inmersys", []);
    }
};

export const getAdminHours = async (year) => {
    try {
        const url = replaceIdURL(Endpoints.project.analisys, "year", year);
        const { data } = await apiaxios.get(url);
        return responseAxios(0, "Obtener", data.payload);
    } catch (error) {
        return responseAxios(1, "Error recuperar proyectos", []);
    }
}


export const deleteProyect = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.deleteProject, "spaceId", id);
        const { data } = await apiaxios.delete(url)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al eliminar", errorResponseGetMsg(error.response));
    }
};

export const deletePermanentProyect = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.deletepermanentProject, "spaceId", id);
        const { data } = await apiaxios.delete(url)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al eliminar", errorResponseGetMsg(error.response));
    }
};

export const unlinkProyect = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.unlinkProject, "spaceId", id);
        const { data } = await apiaxios.put(url, {})
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al desvincular", errorResponseGetMsg(error.response));
    }
};


export const getLPNames = async () => {
    try {
        const url = Endpoints.user.get_LP_users;
        const { data } = await apiaxios.get(url)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
}

export const getLPHours = async ({ leaderId, startAt, endAt }) => {
    try {
        const url = Endpoints.user.get_LP_times;
        console.log({
            leaderId,
            startAt,
            endAt
        })
        const { data } = await apiaxios.post(url, {
            leaderId,
            startAt,
            endAt
        })
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error);
        return responseAxios(1, "error al obtener usuarios", []);
    }
}


export const getCommentsProject = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.project.comments.get, "spaceId", id);
        const { data } = await apiaxios.get(url)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener usuarios", []);
    }
}


export const getTagsRequest = async () => {
    try {
        const { data } = await apiaxios.get(Endpoints.tags.get)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al obtener tags", []);
    }
}
export const postTagsRequest = async (form) => {
    try {
        const { data } = await apiaxios.post(Endpoints.tags.post, form)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al crear tags", []);
    }
}
export const updateTagsRequest = async (id, form) => {
    try {
        const url = replaceIdURL(Endpoints.tags.update, "id", id);
        const { data } = await apiaxios.put(url, form)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al actualizar tags", []);
    }
}

export const deleteTagsRequest = async (id) => {
    try {
        const url = replaceIdURL(Endpoints.tags.update, "id", id);
        const { data } = await apiaxios.delete(url)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al actualizar tags", []);
    }
}


export const fixSubtasks = async (spaceId) => {
    try {
        const url = replaceIdURL('api/project/subtask/:spaceId', "spaceId", spaceId);
        const { data } = await apiaxios.get(url)
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al actualizar tags", []);
    }
}

export const getComercialProjects = async (text) => {
    try {
        const url = 'api/project/comercial';
        const { data } = await apiaxios.post(url, { text })
        return responseAxios(data.status, "", data.payload);
    } catch (error) {
        console.log(error.response);
        return responseAxios(1, "error al solicitar proyectos", []);
    }
}

export const getTableWeeksProjects = async (year) => {
    try {
        const url = replaceIdURL(Endpoints.project.tableWeeks, "year", year);
        const { data } = await apiaxios.get(url);
        return responseAxios(0, "Get table weeks", data.payload);
    } catch (error) {
        return responseAxios(1, "Error al obtener la tabla de semanas", []);
    }
}